import React from 'react';
import * as styles from './index.module.less';
import CommonBlok from '@/components/common-blok';
import MoreFeaturesDisplay from '@/components/more-features-display';
import { FEATURES_DISPLAY_DATA } from '../../constants';

export const AI_NOTE_ID = 'ai-note';

const AINote = () => {
  return (
    <CommonBlok isNewLayout paddingBottom="0" id={AI_NOTE_ID}>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <div className={styles.new_tag}>New</div>
          <MoreFeaturesDisplay
            data={{
              featureDescList: FEATURES_DISPLAY_DATA,
            }}
            titleActiveColor="linear-gradient(115deg, #12CEEB 14.32%, #3089F0 60.79%)"
            swiperBulletActiveColor="#3089F0"
          />
        </div>
      </div>
    </CommonBlok>
  );
};
export default AINote;
